exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flex-container{display:flex;justify-content:space-between;align-items:center}.glyph{margin-bottom:-0.3em;margin-left:20px;margin-right:-5px}\n", ""]);

